export abstract class RouterPath {
    public static Routes = '/pages/routes';
    public static Allocation = '/pages/routes/allocation';
    public static Customers = '/pages/customers';
    public static Invoices = '/pages/invoices';
    // public static Drivers =  '/pages/drivers';
    public static Vehicles = '/pages/vehicles';
    public static Products = '/pages/products';
    public static ProductsBulkUpdate = '/pages/products/bulk-update';
    public static Users = '/pages/users';
    public static Tenants = '/pages/tenants';
    public static Billings = '/pages/billings';
    public static Messages = '/pages/messages';
}
